module.exports = __webpack_public_path__ + "img/mars.61e3b051.jpg";